import { useEffect, useState } from "react";
import { apiFetch, formatLagosDateTime } from "./api";

const emptyClient = {
  name: "",
  address: "",
  contact_name: "",
  contact_phone: "",
  contact_email: ""
};

function ClientDashboard() {
  const [clients, setClients] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [newClient, setNewClient] = useState(emptyClient);
  const [message, setMessage] = useState("");

  function loadClients() {
    apiFetch("/api/clients")
      .then(res => res.json())
      .then(data => setClients(Array.isArray(data) ? data : []));
  }

  useEffect(() => {
    loadClients();
  }, []);

  function updateField(field, value) {
    setNewClient(prev => ({ ...prev, [field]: value }));
  }

  function createClient() {
    if (!newClient.name.trim()) {
      alert("Client name is required");
      return;
    }

    apiFetch("/api/clients", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newClient)
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          alert(data.error);
          return;
        }
        setNewClient(emptyClient);
        setShowForm(false);
        setMessage("Client added");
        loadClients();
        setTimeout(() => setMessage(""), 1800);
      });
  }

  return (
    <div style={page}>
      <div style={headerRow}>
        <div>
          <h2>Client Sales & Projects</h2>
          <p style={muted}>Manage clients, sales lifecycle, and project lifecycle in one place.</p>
        </div>
        <button onClick={() => (window.location.href = "/atc")}>Open ATC Dashboard</button>
      </div>

      <div style={toolbar}>
        <button onClick={() => setShowForm(prev => !prev)}>
          {showForm ? "Close New Client" : "New Client"}
        </button>
        {message && <span style={successText}>{message}</span>}
      </div>

      {showForm && (
        <div style={card}>
          <h3>Add New Client</h3>
          <div style={formGrid}>
            <input placeholder="Client name" value={newClient.name} onChange={e => updateField("name", e.target.value)} />
            <input placeholder="Client address" value={newClient.address} onChange={e => updateField("address", e.target.value)} />
            <input placeholder="Contact person name" value={newClient.contact_name} onChange={e => updateField("contact_name", e.target.value)} />
            <input placeholder="Contact person phone" value={newClient.contact_phone} onChange={e => updateField("contact_phone", e.target.value)} />
            <input placeholder="Contact person email" value={newClient.contact_email} onChange={e => updateField("contact_email", e.target.value)} />
          </div>
          <button style={{ marginTop: "10px" }} onClick={createClient}>Save Client</button>
        </div>
      )}

      <table border="1" cellPadding="10" style={table}>
        <thead>
          <tr>
            <th>S.no.</th>
            <th>Client</th>
            <th>Projects Done (nos.)</th>
            <th>Projects Running (nos.)</th>
            <th>Date Last Edited</th>
            <th>Last Edited By</th>
            <th>Access</th>
          </tr>
        </thead>
        <tbody>
          {clients.length > 0 ? clients.map((client, index) => (
            <tr key={client.id} style={{ cursor: "pointer" }} onClick={() => (window.location.href = `/clients/${client.id}`)}>
              <td>{index + 1}</td>
              <td>{client.name}</td>
              <td>{client.projects_done}</td>
              <td>{client.projects_running}</td>
              <td>{formatLagosDateTime(client.last_edited_at)}</td>
              <td>{client.last_edited_by || ""}</td>
              <td>
                <button onClick={(e) => {
                  e.stopPropagation();
                  window.location.href = `/clients/${client.id}`;
                }}>
                  Open
                </button>
              </td>
            </tr>
          )) : (
            <tr>
              <td colSpan="7">No clients added yet</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

const page = { padding: "20px" };
const headerRow = { display: "flex", justifyContent: "space-between", alignItems: "center", gap: "20px" };
const toolbar = { margin: "16px 0", display: "flex", alignItems: "center", gap: "12px" };
const card = { border: "1px solid #ddd", padding: "15px", marginBottom: "20px", borderRadius: "8px", backgroundColor: "#f9f9f9" };
const formGrid = { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "10px" };
const table = { width: "100%", borderCollapse: "collapse" };
const muted = { color: "#666", marginTop: 0 };
const successText = { color: "green", fontWeight: "bold" };

export default ClientDashboard;
